<template>
   <section class="static-page-hero">
      <Image
         :image="field.image"
         v-if="field.image"
         fit="cover"
         class="background"
      />

      <div class="content">
         <h1>{{ field.headline }}</h1>
         <p>{{ field.content }}</p>
         <Btn
            classes="yellow mt-2 transparent"
            v-bind="{ text: field.btn_text, url: field.btn_url, target: true }"
         />
      </div>
   </section>
</template>

<script setup lang="ts">
const props = defineProps({
   layout: { type: String, required: true },
   attributes: { type: Object, required: true },
});
const field = toRef(props, "attributes");
</script>

<style lang="scss" scoped>
section.static-page-hero {
   height: 80vh;
   width: 100vw;
   display: grid;
   justify-content: flex-start;
   align-items: flex-end;
   position: relative;
   overflow: hidden;
   figure.background {
      position: absolute;
      inset: 0;
      z-index: 0;
      &:after {
         content: "";
         position: absolute;
         inset: 30% 0 0 0;
         background: linear-gradient(transparent, $black);
         mix-blend-mode: multiply;
      }
   }
   div.content {
      z-index: 1;
      position: relative;
      @include ml(1, 1, 1);
      @include width(5, 4);
      padding-bottom: pad(10);
      color: white;
   }
}
</style>
